import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faHeart} from '@fortawesome/free-solid-svg-icons';
import {faHeart as faHeartOutline} from '@fortawesome/free-regular-svg-icons';

export const Hearts = ({
    lives,
    maxLives = 3,
    showOutlineLives = false,
    size,
    center,
    heartClassName = '',
}: {
    lives: number;
    maxLives?: number;
    showOutlineLives?: boolean;
    size?: number;
    center?: boolean;
    heartClassName?: string;
}) => {
    const outlineLives = maxLives - lives;
    return (
        <div
            className={`flex items-center min-w-16 gap-1 ${center ? 'justify-center' : ''}`}>
            {Array.from({length: lives}, (_, index) => (
                <FontAwesomeIcon
                    key={`heart-${index}`}
                    icon={faHeart}
                    fontSize={size}
                    className={`text-red-600 ${heartClassName}`}
                />
            ))}
            {showOutlineLives &&
                Array.from({length: outlineLives}, (_, index) => (
                    <FontAwesomeIcon
                        key={`heart-outline-${index}`}
                        icon={faHeartOutline}
                        fontSize={size}
                        className={`text-red-600 ${heartClassName}`}
                    />
                ))}
        </div>
    );
};
